export default {
  setCurrentWalletProvider ({ commit }, value) {
    commit('setCurrentWalletProvider', value)
  },
  setIsWalletConnected ({ commit }, value) {
    commit('setIsWalletConnected', value)
  },
  setWallets ({ commit }, payload) {
    commit('setWallets', payload)
  },
  setTokensAssetsProfile ({ commit }, payload) {
    commit('setTokensAssetsProfile', payload)
  },
  setTokensInfo ({ commit }, payload) {
    commit('setTokensInfo', payload)
  },
  setTokensWithBalance ({ commit }, payload) {
    commit('setTokensWithBalance', payload)
  },
  setTokensAvaliable ({ commit }, payload) {
    commit('setTokensAvaliable', payload)
  },
  setCurrentBestRate ({ commit }, payload) {
    commit('setCurrentBestRate', payload)
  },
  increaseGetBestRateCount ({ commit }) {
    commit('increaseGetBestRateCount')
  },
  setTransactionHistory ({ commit }, payload) {
    commit('setTransactionHistory', payload)
  },
  pushTransactionHistory ({ commit }, payload) {
    commit('pushTransactionHistory', payload)
  },
  setUnreadTxHistoryAmount ({ commit }, payload) {
    commit('setUnreadTxHistoryAmount', payload)
  },
  setUnreadUserNotiAmount ({ commit }, payload) {
    commit('setUnreadUserNotiAmount', payload)
  },
  markTxHistoryAsUnread ({ commit }, payload) {
    commit('markTxHistoryAsUnread', payload)
  },
  setCurrentNetwork ({ commit }, value) {
    commit('setCurrentNetwork', value)
  },
  setUser ({ commit }, user) {
    commit('setUser', user)
  },
  setCurrentWeb3 ({ commit }, web3) {
    commit('setCurrentWeb3', web3)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js